import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../../../../../services/languageUtils';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputMask from 'react-input-mask';


function TransferTypePix({ contacts, handlePixKeyClick, currentPayment, pixKeyType, keySearchPix, handleChangeKeyPix, handleKeyTypeChange, searchKeyDict }){
  const [translations, setTranslations] = useState({});
  let inputMask = "";

  switch (pixKeyType) {
    case "CPF":
      inputMask = "999.999.999-99";
      break;
    case "CNPJ":
      inputMask = "99.999.999/9999-99";
      break;
    case "Telefone":
      inputMask = "(99) 99999-9999";
      break;
    default:
      inputMask = "";
  }

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations((localStorage.getItem('language') || 'pt'));
      setTranslations(trans);
    };
    loadTranslations();
  }, []);
  return (
    <div>
      <span className="desktop">
        <div className="mainContent">
          <p className="pTitle">{translations.who_to_transfer}</p>
          <p className="pLabel"><br />{translations.search_by_contact_or_pix_key}</p>
          <select className="select" value={pixKeyType} onChange={handleKeyTypeChange}>
            <option value="CPF">CPF</option>
            <option value="CNPJ">CNPJ</option>
            <option value="Telefone">Telefone</option>
            <option value="Email">Email</option>
            <option value="Chave Aleatória">Chave Aleatória</option>
          </select>
          <InputMask
            type="text"
            placeholder={translations.pix_key}
            className="input"
            id="keySearchPix"
            mask={inputMask}
            value={keySearchPix}
            onChange={handleChangeKeyPix}
          />
          <div 
            className="buttonNewContact" 
            onClick={() => searchKeyDict(keySearchPix, "key")}
          >
            {translations.next}
          </div>
        </div>

        <div className="mainContent" style={{ borderRadius: "0px 8px 8px 0px" }}>
          <p className="pTitle">{translations.transfer_to_frequent_contacts}</p><br />
          <div className="contact-list">
            {contacts.map((contact, index) => 
              {
                if(contact.pixKeys.length > 0){
                  return (
                <div key={index} className="contact-card">
                  <span>
                    <div className="initials-circle">
                      {`${contact.contact.userEmail[0].toUpperCase()}`}
                    </div>
                  </span>
                  <div className="contact-info">
                    <div className="name">{contact.contact.contactName}</div>
                    <div className="last-contact">{contact.contact.doc}</div>
                  </div>
                  <div className="pix-keys">
                    {contact.pixKeys.map((key, index) => (
                      <button
                        key={index}
                        className="pix-key-button"
                        onClick={() => handlePixKeyClick(key, contact.contact)}
                      >
                        {key.pixKey}
                      </button>
                    ))}
                  </div>
                </div>
                  )
                }
                return (<div></div>)
              }
            )}
          </div>
        </div>
      </span>
      
      <span className="mobile">
        <div>
          <div className="mainContent">
            <p className="pTitle">{translations.who_to_transfer}</p>
            <p className="pLabel"><br />{translations.search_by_contact_or_pix_key}</p>
            <select className="select" value={pixKeyType} onChange={handleKeyTypeChange}>
              <option value="CPF">CPF</option>
              <option value="CNPJ">CNPJ</option>
              <option value="Telefone">Telefone</option>
              <option value="Email">Email</option>
              <option value="Chave Aleatória">Chave Aleatória</option>
            </select>
            <InputMask
              type="text"
              placeholder={translations.pix_key}
              className="input"
              id="keySearchPix"
              mask={inputMask}
              value={keySearchPix}
              onChange={handleChangeKeyPix}
            />
            {/* Só a chave: nome e documento de quem recebe vêm da consulta ao DICT. */}
            <div
              className="buttonNewContact" 
              onClick={() => searchKeyDict(keySearchPix, "key")}
            >
              {translations.next}
            </div><br/><br/>

            <p className="pLabel">{translations.frequent_transfer_contacts}</p>
          </div>
        </div>
      </span>
      <ToastContainer />
    </div>
  );
}

export default TransferTypePix;
